import { registerEnumSet } from '@if/mui'
import { CheckCircle2, XCircle } from 'lucide-react'

/** User account status — the two states the `accountEnabled` flag maps to. */
export enum EAccountStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

// Registers the account statuses as enum chips (color + icon + label) in the
// shared @if/mui enum registry, so the Manage Users grid renders the Status
// column via `type: 'enumChip'` and gets the same chip look as every other status
// surface. Load-once side-effect — imported at app bootstrap (main.tsx).
registerEnumSet(EAccountStatus, {
  [EAccountStatus.Active]: { color: 'success', icon: CheckCircle2, labelKey: 'accountStatus.active' },
  [EAccountStatus.Inactive]: { color: 'secondary', icon: XCircle, labelKey: 'accountStatus.inactive' },
})
